import type { RouteConfig } from 'vue-router';

/**
 * 活动类路由,
 * app内活动展示navbar
 * 不需要展示navbar, 通过设置customNavBar: true，页面不增加navbar组件。
 */
export default [
  /**
   * 营销类广告
   */
  {
    path: '/activity/advert-marketing/:type',
    meta: {
      excludeLogin: true,
      excludeTracking: true,
      title: '宜享花',
    },
    component: () => import('@/views/activity/advert-marketing.vue'),
  },
  // /**
  //  * MGM邀请者
  //  */
  // {
  //   path: '/activity/mgm',
  //   meta: {
  //     excludeLogin: true,
  //     title: '邀好友 赚高额奖励',
  //     customNavBar: true,
  //   },
  //   component: () => import('@/views/activity/mgm/index.vue'),
  // },
  // /**
  //  * MGM被邀请者
  //  */
  // /* {
  //   path: '/activity/mgm/invitee',
  //   meta: {
  //     excludeLogin: true,
  //     title: '邀好友 赚高额奖励',
  //     background: '#fff',
  //     customNavBar: true, // app外活动，不需要展示navbar
  //   },
  //   component: () => import('@/views/activity/mgm/invitee.vue'),
  // }, */
  // /**
  //  * MGM邀请列表
  //  */
  // {
  //   path: '/activity/mgm/list',
  //   meta: {
  //     title: '我的邀请列表',
  //     background: '#fff',
  //   },
  //   component: () => import('@/views/activity/mgm/list.vue'),
  // },
  // /**
  //  * MGM收益明细
  //  */
  // {
  //   path: '/activity/mgm/income',
  //   meta: {
  //     title: '收益明细',
  //     background: '#F0F9FF',
  //   },
  //   component: () => import('@/views/activity/mgm/income-list.vue'),
  // },
  /**
   * 新客专享
   */
  {
    path: '/activity/newcomer-vip/:type',
    meta: {
      excludeLogin: true,
      title: '新客专享',
      background: '#5f4cfd',
    },
    component: () => import('@/views/activity/newcomer-vip/index.vue'),
  },
  /**
   * 新客专享规则
   */
  {
    path: '/activity/newcomer-vip/rule/:type',
    meta: {
      excludeLogin: true,
      title: '券规则',
      background: '#5f4cfd',
    },
    component: () => import('@/views/activity/newcomer-vip/rule.vue'),
  },
  /**
   * 拒就赔活动
   */
  {
    path: '/activity/jjp',
    meta: {
      excludeLogin: true,
      title: '拒就赔',
      customNavBar: true,
    },
    component: () => import('@/views/activity/jjp/index.vue'),
  },

  {
    path: '/activity-page',
    redirect: '/activity/customization',
  },
  {
    path: '/activity-page/preview',
    redirect: '/activity/customization/preview',
  },
  {
    path: '/activity-page/download-app',
    redirect: '/activity/customization/download-app',
  },
  /**
   * 自定义活动页
   */
  {
    path: '/activity/customization',
    meta: {
      excludeTracking: true,
      customNavBar: true,
      excludeLogin: true,
      enableActToken: true,
    },
    component: () => import('@/views/activity-page/index.vue'),
  },
  /**
   * 自定义活动页预览
   */
  {
    path: '/activity/customization/preview',
    meta: {
      customNavBar: true,
      excludeLogin: true,
      enableActToken: true,
    },
    component: () => import('@/views/activity-page/index.vue'),
  },
  /**
   * 自定义活动页下载APP
   */
  {
    path: '/activity/customization/download-app',
    meta: {
      excludeLogin: true,
      enableActToken: true,
    },
    component: () => import('@/views/activity-page/download-app.vue'),
  },
  {
    path: '/points/sign-in/lucky-wheel',
    redirect: '/activity/raffle',
  },

  {
    path: '/points/download-app',
    redirect: '/activity/raffle/download-app',
  },
  /**
   * 抽奖活动
   */
  {
    path: '/activity/raffle',
    meta: {
      title: ' ',
      customNavBar: true,
      showFooter: false,
      excludeLogin: true,
      excludeTracking: true,
      enableActToken: true,
    },
    component: () => import('@/views/points/sign-in/lucky-wheel.vue'),
  },
  /**
   * 抽奖活动下载APP
   */
  {
    path: '/activity/raffle/download-app',
    meta: {
      excludeLogin: true,
      enableActToken: true,
    },
    component: () => import('@/views/points/download-app.vue'),
  },
  /**
   * 企业微信红包
   */
  {
    path: '/activity/wechat-work/red-packet',
    meta: {
      excludeLogin: true,
      customNavBar: true,
      background: '#fffbef',
    },
    component: () => import('@/views/activity/wechat-work-red-packet/index.vue'),
  },
  /**
   * 企业微信新客红包
   * 企业微信二维码
   */
  {
    path: '/activity/wechat-work/red-packet/newcomer/qr-code',
    meta: {
      title: '企微落地页',
      excludeTracking: true,
      excludeLogin: true,
      customNavBar: true,
      background: '#fffbef',
    },
    component: () => import('@/views/activity/wechat-work-red-packet-newcomer/QRCode.vue'),
  },
  /**
   * 企业微信新客红包
   * 领取页面
   */
  {
    path: '/activity/wechat-work/red-packet/newcomer/revieve-page',
    meta: {
      excludeLogin: true,
      excludeTracking: true,
      customNavBar: true,
      background: '#fffbef',
    },
    component: () => import('@/views/activity/wechat-work-red-packet-newcomer/index.vue'),
  },
  /**
   * 企业微信新客红包-短信渠道落地页
   * 短信渠道发送链接后，手机浏览器打开这个落地页，【点击｜自动】跳转微信小程序落地页
   */
  {
    path: '/activity/wechat-work/red-packet/newcomer/sms-landing-page',
    meta: {
      title: '营销中转页',
      excludeTracking: true,
      excludeLogin: true,
      customNavBar: true,
      background: '#fffbef',
    },
    component: () =>
      import('@/views/activity/wechat-work-red-packet-newcomer/sms-landing-page.vue'),
  },
  /**
   * 企业微信新客红包-【电销】短信渠道落地页
   * 短信渠道发送链接后，手机浏览器打开这个落地页，【点击｜自动】跳转微信小程序落地页
   */
  {
    path: '/activity/wechat-work/red-packet/newcomer/dx-sms-landing-page',
    meta: {
      title: '营销中转页',
      excludeTracking: true,
      excludeLogin: true,
      customNavBar: true,
      background: '#fffbef',
    },
    component: () =>
      import('@/views/activity/wechat-work-red-packet-newcomer/dx-sms-landing-page.vue'),
  },
  /**
   * 应用商店好评
   */
  {
    path: '/activity/app-store-comment',
    meta: {
      title: '评价有礼',
    },
    component: () => import('@/views/activity/app-store-comment/index.vue'),
  },
  {
    path: '/activity/app-store-comment/image-upload',
    meta: {
      title: '上传评价截图',
    },
    component: () => import('@/views/activity/app-store-comment/image-upload.vue'),
  },
  {
    path: '/activity/app-store-comment/audit',
    meta: {
      title: '审核中',
      customNavBar: true,
    },
    component: () => import('@/views/activity/app-store-comment/audit.vue'),
  },
  {
    path: '/activity/app-store-comment/user-feedback',
    meta: {
      title: '用户反馈',
    },
    component: () => import('@/views/activity/app-store-comment/user-feedback.vue'),
  },
  /**
   * 应用商店好评落地页
   * 仅在 app 我的页面，使用此路由展示落地页
   */
  {
    path: '/activity/app-store-comment/landing-page',
    meta: {
      customNavBar: true,
      background: 'transparent',
    },
    component: () => import('@/views/activity/app-store-comment/landing-page.vue'),
  },
] as RouteConfig[];
